// Session-start PCM sample rate selection for Phase 3 adaptive streaming.
// See docs/planning/deepgram_streaming_robustness.md §3 Phase 3 + §4 Q2.

/** Locked Deepgram upstream rates for linear16 PCM. */
export const DEEPGRAM_PCM_SAMPLE_RATE_HZ = {
  HIGH: 16_000,
  LOW: 8_000,
} as const;

export type DeepgramPcmSampleRateHz =
  | typeof DEEPGRAM_PCM_SAMPLE_RATE_HZ.HIGH
  | typeof DEEPGRAM_PCM_SAMPLE_RATE_HZ.LOW;

const SLOW_EFFECTIVE_TYPES = new Set(["slow-2g", "2g", "3g"]);

/**
 * Pick 8 kHz on slow-2g/2g/3g; otherwise 16 kHz (4g, 5g, or unknown).
 * Sampled once per session at `start()` — no mid-session degrade.
 */
export function selectPcmSampleRateHz(effectiveType: string | null): DeepgramPcmSampleRateHz {
  if (effectiveType && SLOW_EFFECTIVE_TYPES.has(effectiveType)) {
    return DEEPGRAM_PCM_SAMPLE_RATE_HZ.LOW;
  }
  return DEEPGRAM_PCM_SAMPLE_RATE_HZ.HIGH;
}
